"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerResetPasswordRequest = void 0;
const React = require("react");
const react_1 = require("react");
const Form_1 = require("../../../../../components/base/forms/Form");
const Message_1 = require("../../../../../components/base/atoms/Message");
const SlimSection_1 = require("../../../../../components/base/structure/SlimSection");
const useClient_1 = require("../../../../../hooks/useClient");
const localStorageKey_1 = require("../helpers/localStorageKey");
const formSchema = [
    {
        type: "email",
        required: true,
        label: "Email",
        map: "email",
        hideKeypad: true,
        description: "Please enter a valid email address. We will send a link to reset your password."
    }
];
const RetailCustomerResetPasswordRequest = () => {
    const client = (0, useClient_1.useClient)();
    const [showError, setShowError] = (0, react_1.useState)(false);
    const [success, setSuccess] = (0, react_1.useState)(false);
    const [successfullySentTo, setSuccessfullySentTo] = (0, react_1.useState)(null);
    const onSuccessHandler = (0, react_1.useCallback)((data) => {
        const { email } = data;
        return client.retailCustomers
            .sendPasswordResetToken(email)
            .then(() => {
            setSuccess(true);
            setSuccessfullySentTo(email);
        })
            .catch(e => {
            console.error(e);
            setShowError(true);
        });
    }, []);
    return (React.createElement(SlimSection_1.SlimSection, null,
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Request for resetting your password")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            !success && (React.createElement(Form_1.Form, { schema: formSchema, onSuccess: data => {
                    setShowError(false);
                    onSuccessHandler(data);
                }, disableOnSuccess: false, data: {
                    // if we have a saved customer email, offer it as default value
                    email: window.localStorage.getItem(localStorageKey_1.TLocalStorageKey.Email)
                }, submitLabel: "Send password reset link" })),
            success && (React.createElement(Message_1.Message, null,
                React.createElement(Message_1.MessageTitle, null, "Email successfully sent."),
                React.createElement(Message_1.MessageBody, null,
                    "The email has been sent to ",
                    successfullySentTo,
                    ". If you don't receive it in a few minutes, please make sure you entered the correct address and try again."))),
            showError && (React.createElement(Message_1.ErrorMessage, null,
                React.createElement(Message_1.MessageTitle, null, "Unable to send password reset link"),
                React.createElement(Message_1.MessageBody, null, "It looks like something went wrong. Please try again."))))));
};
exports.RetailCustomerResetPasswordRequest = RetailCustomerResetPasswordRequest;
//# sourceMappingURL=index.js.map